import httpClientImmigration from "@/services/httpClientImmigration";
import { server } from "@/services/constants";

export const getdataByIdim_docket = (id) => {
  return httpClientImmigration.get(server.IM_DOCKET + `/getbyid/${id}`);
};

export const getAllim_docket_Company = (query) => {
  return httpClientImmigration.get(
    server.IM_DOCKET + `/getAllim_docket_Company`,
    query,
  );
};

export const getAllim_docket_CompanyPagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
) => {
  return httpClientImmigration.get(
    server.IM_DOCKET + `/getAllim_docket_CompanyPagination`,
    { params: { page, limit, sortBy, sortOrder, company_id } },
  );
};

export const getAllim_docket_CompanyPaginationV2 = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  search,
) => {
  return httpClientImmigration.get(
    server.IM_DOCKET + `/getAllim_docket_CompanyPaginationV2`,
    { params: { page, limit, sortBy, sortOrder, company_id, search } },
  );
};

export const getfileno_im_docket_Company = (query) => {
  return httpClientImmigration.get(
    server.IM_DOCKET + `/getfileno_im_docket_Company`,
    query,
  );
};

export const addim_docket = (data) => {
  return httpClientImmigration.post(server.IM_DOCKET + `/`, data);
};

export const updateim_docket = (id, data) => {
  return httpClientImmigration.put(server.IM_DOCKET + `/${id}`, data);
};

export const updateByfile_noim_docket = (id, data) => {
  return httpClientImmigration.put(
    server.IM_DOCKET + `/updateByfile_no/${id}`,
    data,
  );
};

export const updateByIDtransaction = (id, data) => {
  return httpClientImmigration.put(
    server.IM_DOCKET + `/updateByID/${id}`,
    data,
  );
};

export const deleteim_docket = (id) => {
  return httpClientImmigration.delete(server.IM_DOCKET + `/${id}`);
};
